var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.984 1.577c0-.025.017-.05.016-.074l-6.714 6.469 6.706 6.262c.004-.045-.008-.09-.008-.136V1.578zm-7.723 7.39l-2.74 2.637a.715.715 0 01-.986.008L7.802 9.065l-6.75 6.506c.164.059.34.104.525.104H20.47c.274 0 .531-.083.755-.208l-6.964-6.5z",
    fill: "#0E425B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.016 10.1L21.262.23A1.552 1.552 0 0020.47 0H1.577C1.2 0 .855.146.586.37l10.43 9.73zM0 1.817v12.281c0 .141.032.277.068.407l6.665-6.419L0 1.817z",
    fill: "#0E425B"
  })));
}

export default SvgEmail;